function initSwiper(el) {
  if (!el || typeof Swiper === 'undefined') return;

  let swiper = null;

  const desktopSlider = el.dataset.desktopSlider === 'true';
  const mobileSlider = el.dataset.mobileSlider === 'true';

  function createSwiper() {
    if (swiper) return;

    swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,

      // freeMode: {
      //   enabled: true,
      //   sticky: false
      // },

      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true
      },

      watchOverflow: true,
      observer: true,
      observeParents: true,

      breakpoints: {
        0: {
          initialSlide: 2,
          spaceBetween: 8,
          centeredSlides: true,
          loop: true,
        },
        750: {
          spaceBetween: 16
        },
        1200: {
          spaceBetween: 20
        }
      }
    });

    el.classList.add('is-swiper');
  }

  function destroySwiper() {
    if (!swiper) return;

    swiper.destroy(true, true);
    swiper = null;

    el.classList.remove('is-swiper');
  }

  function updateMode() {
    const isMobile = window.innerWidth < 750;
    const shouldSlide = isMobile ? mobileSlider : desktopSlider;

    if (shouldSlide) {
      createSwiper();
    } else {
      destroySwiper();
    }
  }

  updateMode();

  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      updateMode();

      if (swiper) {
        swiper.update();
      }
    }, 150);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.ellaya-insta-feed__viewport.swiper')
    .forEach(initSwiper);
});

document.addEventListener('click', function (e) {

  const soundBtn = e.target.closest('.ellaya-video-sound-toggle');

  if (!soundBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const currentVideo = soundBtn
    .closest('.ellaya-insta-feed__media-button')
    ?.querySelector('video');

  if (!currentVideo) return;

  const wasMuted = currentVideo.muted;

  document.querySelectorAll('.ellaya-insta-feed__media-button video').forEach(video => {
    video.muted = true;

    const btn = video
      .closest('.ellaya-insta-feed__media-button')
      ?.querySelector('.ellaya-video-sound-toggle');

    if (btn) {
      btn.classList.remove('active');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 3 9 3 15 6 15 11 19 11 5"/><line x1="16" y1="9" x2="21" y2="14"/><line x1="21" y1="9" x2="16" y2="14"/></svg>';
    }
  });

  if (wasMuted) {
    currentVideo.muted = false;
    currentVideo.volume = 1;
    currentVideo.play();

    soundBtn.classList.add('active');
    soundBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 3 9 3 15 6 15 11 19 11 5"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18 6a8.5 8.5 0 0 1 0 12"/></svg>';
  }
});